/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useForm, Controller} from 'react-hook-form';
import Box from "@mui/material/Box";
import { HugeiconsIcon } from "@hugeicons/react";
import { NotificationManager } from "react-notifications";
import type { appConfigs, RootState } from "../types/types";
import { useDropzone } from "react-dropzone";
// @ts-ignore
import Papa from "papaparse/papaparse.min.js";
import { uploadBulkCampaignCsv,getBulkEmailDetails } from "src/services/bulkEmailServices";
//@ts-ignore
import { AddCircleStrokeRounded,  HelpCircleIcon,  CircleArrowRight01Icon} from "@hugeicons-pro/core-stroke-rounded";
import { FormControl, Autocomplete, TextField, IconButton, Checkbox, Chip } from "@mui/material";
import CustomTooltip from "../CustomTooltip/CustomTooltip";
import { CHOOSE_SEEDLIST_MESSAGE, CHOOSE_SUPPRESSIONLIST_MESSAGE } from "src/constants/constant";
// @ts-ignore
import { ArrowDown01Icon } from "@hugeicons-pro/core-stroke-standard";
import { getAllSeedListByClientId } from "src/services/seedListService";
import { getAllSuppressionListByClientId } from "src/services/suppressionListService";
import { useSelector } from "react-redux";
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import type { TableColumn } from 'react-data-table-component';
import MUIModal from "../MUIModal/MUIModal";
import { useParams } from "react-router-dom";
import type { TooltipProps } from '@mui/material/Tooltip';
import Tooltip,  {tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

interface SeedListPropType {
  seedList: any;
  seedListData: any[];
}

interface ApiResponse {
  status: number;
  data: {
    data: SeedListPropType[];
    result: number;
  };
}

interface SuppressionListPropType {
  suppressionList: any;
  suppressionListData: any[];
}

interface SuppressionApiResponse {
  status: number;
  data: {
    data: SuppressionListPropType[];
    result: number;
  };
}

interface SummaryDataType {
  metric: string;
  count: number;
  hasInfo: boolean;
  isError?: boolean;
  type: string;
}

interface DomainDataType {
  domain: string;
  percentage: number;
  count: number;
}

interface BulkEmailImportCSVProps {
  onFileUploadSuccess: (uploadData: any) => void;
  onFileRemoval: () => void;
  onSeedListChange?: (seedList: any) => void;
  onSuppressionListChange?: (suppressionList: any) => void;
  isEditMode?: boolean;
  existingFileData?: {
    originalCampaignData?: {
      bulkCampaignId?: number;
      bulkCampaignIdentifier: string;
      bulkCampaignDataIdentifier?: string | number;
      sourceCSVFileName?: string;
      uploadedCSVFileName?: string;
      seedListId?: number;
      supressionListId?: number;
      [key: string]: any;
    };
  };
  onTotalRecipientsCalculated?: (total: number, seedCount: number, emailsSuppressed: number, emailsUploaded:number) => void;
}

interface EmailDetail {
  npi: string;
  firstName: string;
  lastName: string;
  title: string;
  specialty: string;
  emailDomain: string;
  email: string;
  isSeedData: boolean | null;
  isSuppressedData: boolean | null;
  isUnsubscribed: boolean | null;
}
const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} placement="bottom" />
  ))(({ theme }) => ({
      [`& .${tooltipClasses.arrow}`]: {
          color: theme.palette.common.white,
      },
      [`& .${tooltipClasses.tooltip}`]: {
          backgroundColor: theme.palette.common.black,
      },
  }));

export default function BulkEmailImportCSV({ 
   onFileUploadSuccess,
  onFileRemoval,
  onSeedListChange,
  onSuppressionListChange,
  isEditMode = false,
  existingFileData,
  onTotalRecipientsCalculated
}: BulkEmailImportCSVProps): JSX.Element {
  const { control, formState: { errors } } = useForm(); // <-- Add this line
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [MaxRequestBodySizeData, setMaxRequestBodySizeData] = useState<string>("");
  const [showSeedList, setShowSeedList] = useState<boolean>(false);
  const [showSuppressionList, setShowSuppressionList] = useState<boolean>(false);
  const { user } = useSelector((state: RootState) => state.auth);
  const [loading, setLoading] = useState<boolean>(true);
  const [emailDetailsLoading, setEmailDetailsLoading] = useState<boolean>(true);
  const [seedList, setSeedList] = useState<any[]>([]);
  const [suppressionList, setSuppressionList] = useState<any[]>([]);
  const [bulkCampaignDataIdentifier, setBulkCampaignDataIdentifier] = useState<string>("");
  const [sourceCSVFileName, setSourceCSVFileName] = useState<string>("");
  const [uploadedCSVFileName, setUploadedCSVFileName] = useState<string>("");
  const [selectedSeedList, setSelectedSeedList] = useState<any>(null);
  const [selectedSuppressionList, setSelectedSuppressionList] = useState<any>(null);
  const [summaryData, setSummaryData] = useState<SummaryDataType[]>([]);
  const [domainData, setDomainData] = useState<DomainDataType[]>([]);
  const [showTables, setShowTables] = useState<boolean>(false);
  const [isLoadingTableData, setIsLoadingTableData] = useState<boolean>(false);
  const [showEmailDetails, setShowEmailDetails] = useState<boolean>(false);
  const [selectedMetricName, setSelectedMetricName] = useState<string>("");
  const [emailDetails, setEmailDetails] = useState<any[]>([]);
  const [CsvColumnsRequiredData, setCsvColumnsRequiredData] = useState<string>("");
  const lastSeedRef = useRef<string>("");  
  const lastSuppressionRef = useRef<string>("");

  const param = useParams();
  const { id } = param;
  
  useEffect(() => {
    const storedAppConfig = localStorage.getItem("appConfigs");
    if (storedAppConfig) {
      try {
        const parsedAppConfig = JSON.parse(storedAppConfig) as appConfigs[];
        const maxRequestBodySize = parsedAppConfig.find(
          (item) => item.configName === "MaxRequestBodySize"
        )?.configValue;
        if (maxRequestBodySize) {
          setMaxRequestBodySizeData(maxRequestBodySize);
        }
        const CsvColumnsRequired = parsedAppConfig.find(
          (item) => item.configName === "CSVColumnsRequired"
        )?.configValue;
        if (CsvColumnsRequired) {
           setCsvColumnsRequiredData(CsvColumnsRequired);
        }
      } catch (error) {
        console.error("Error parsing appConfig data:", error);
      }
    }
    getSeedListData();
    getSuppressionListData();
  }, []);
  
  useEffect(() => {
    if (isEditMode && existingFileData?.originalCampaignData) {
      const data = existingFileData.originalCampaignData;

      const identifier =
        data.bulkCampaignDataIdentifier?.toString() ??
        data.bulkCampaignIdentifier?.toString() ??
        "";

      console.log("DEBUG setting identifier ->", identifier);

      setBulkCampaignDataIdentifier(identifier);
      setSourceCSVFileName(data.sourceCSVFileName ?? "");
      setUploadedCSVFileName(data.uploadedCSVFileName ?? "");

      if (data.seedListId) setShowSeedList(true);
      if (data.supressionListId) setShowSuppressionList(true);
    }
  }, [isEditMode, existingFileData?.originalCampaignData]);


const hasTriggeredRef = useRef(false);
const initialLoadHandledRef = useRef(false);


  useEffect(() => {
    if (
      isEditMode &&
      bulkCampaignDataIdentifier &&
      uploadedCSVFileName &&
      sourceCSVFileName &&
      !hasTriggeredRef.current
    ) {
      hasTriggeredRef.current = true;
      initialLoadHandledRef.current = true;

      const initialSeed = selectedSeedList ?? existingFileData?.originalCampaignData?.seedListId

      const initialSuppression = selectedSuppressionList ?? existingFileData?.originalCampaignData?.supressionListId

      void triggerUploadApi(initialSeed, initialSuppression);
    }
  }, [
    isEditMode,
    bulkCampaignDataIdentifier,
    uploadedCSVFileName,
    sourceCSVFileName,
    selectedSeedList,
    selectedSuppressionList,
    existingFileData?.originalCampaignData,
  ]);

  const handleEmailDetails = (metricName: string,type: string): void => {
    setEmailDetailsLoading(true);
    setShowEmailDetails(true);
    setSelectedMetricName(metricName);
    getBulkEmailDetails(bulkCampaignDataIdentifier, type)
      .then(
        (res: any) => {
          console.log(res);
          if (res.status === 200) {
            console.log(res.data);
            if (res.data.result === 1) {
              setEmailDetailsLoading(false);
              const emailDetails = res.data.data;
              setEmailDetails(emailDetails)
            } else {
              setEmailDetailsLoading(false);
              setEmailDetails([])
            }
          }
        }
      )
      .catch(
        (error: any) => {
          console.log("Error: ", error);
          setEmailDetailsLoading(false);
        }
      )
  }

  const summaryColumns: TableColumn<SummaryDataType>[] = [
    {
      name: 'Metric',
      selector: (row: SummaryDataType) => row.metric,
      cell: (row: SummaryDataType) => (
        <div className="flex items-center">
          <span 
            className={`text-14 font-medium ${row.isError ? 'text-red-600' : 'text-muted'} ${
              row.count > 0 && row.type !== "EmailTotal" ? 'cursor-pointer hover:underline' : ''
            }`}
            onClick={() => {
              if (row.count > 0 && row.type !== "EmailTotal") {
                handleEmailDetails(row.metric, row.type);
              }
            }}
          >
            {row.metric}
          </span>
        </div>
      ),
      width: '70%',
    },
    {
      name: <div style={{ textAlign:  "center", width: "100%" }}>Count</div>,
      selector: (row: SummaryDataType) => row.count,
      cell: (row: SummaryDataType) => (
        <div className={`text-14 font-medium ${row.isError ? 'text-red-600' : 'text-muted'}`} style={{ textAlign:  "center", width: "100%" }}>
          {row.count.toLocaleString()}
        </div>
      ),
      width: '30%'
    },
  ];

  const domainColumns: TableColumn<DomainDataType>[] = [
    {
      name: 'Domain',
      selector: (row: DomainDataType) => row.domain,
      cell: (row: DomainDataType) => (
        <div className="text-14 font-medium text-muted">
          {row.domain}
        </div>
      ),
      width: '40%',
    },
    {
      name: <div style={{ textAlign:  "center", width: "100%" }}>%</div>,
      selector: (row: DomainDataType) => row.percentage,
      cell: (row: DomainDataType) => (
        <div className="text-14 font-medium text-muted" style={{ textAlign:  "center", width: "100%" }}>
          {row.percentage}%
        </div>
      ),
      width: '30%',
      center: true,
    },
    {
      name:  <div style={{ textAlign:  "center", width: "100%" }}>Count</div>,
      selector: (row: DomainDataType) => row.count,
      cell: (row: DomainDataType) => (
        <div className={`text-14 font-medium text-muted`} style={{ textAlign:  "center", width: "100%" }}>
          {row.count.toLocaleString()}
        </div>
      ),
      width: '30%'
    },
  ];

  const emailDetailsColumns = [
    {
      name: "NPI",
      selector: (row: EmailDetail) => row.npi,
      sortable: true,
      cell: (row: EmailDetail) => {
        return (
          <div className="flex items-center">
            <BootstrapTooltip title={row.npi} arrow>
              <span className="truncate">
                {row.npi}
              </span>
            </BootstrapTooltip>
          </div>
        );
      },
      width:'15%'
    },
    {
      name: "First Name",
      selector: (row: EmailDetail) => row.firstName,
      sortable: true,
      cell: (row: EmailDetail) => {
        return (
          <div className="flex items-center">
            <BootstrapTooltip title={row.firstName} arrow>
              <span className="truncate">
                {row.firstName}
              </span>
            </BootstrapTooltip>
          </div>
        );
      },
      width:'15%'
    },
    {
      name: "Last Name",
      selector: (row: EmailDetail) => row.lastName,
      sortable: true, 
      cell: (row: EmailDetail) => {
        return (
          <div className="flex items-center">
            <BootstrapTooltip title={row.lastName} arrow>
              <span className="truncate">
                {row.lastName}
              </span>
            </BootstrapTooltip>
          </div>
        );
      },
      width:'15%'
    },
    {
      name: "Specialty",
      selector: (row: EmailDetail) => row.specialty,
      sortable: true,
      cell: (row: EmailDetail) => {
        return (
          <div className="flex items-center">
            <BootstrapTooltip title={row.specialty} arrow>
              <span className="truncate" style={{ maxWidth: "100px" }}>
                {row.specialty}
              </span>
            </BootstrapTooltip>
          </div>
        );
      },
      width:'18%'
    },
    {
      name: "Email",
      selector: (row: EmailDetail) => row.email,
      sortable: true,
      cell: (row: EmailDetail) => {
        return (
          <div className="flex items-center">
            <BootstrapTooltip title={row.email} arrow>
              <span className="truncate" style={{ maxWidth: "100px" }}>
                {row.email}
              </span>
            </BootstrapTooltip>
          </div>
        );
      },
      width:'15%'
    },
    {
      name: "Suppressed",
      selector: (row: EmailDetail) =>
        row.isSuppressedData === null ? "N/A" : row.isSuppressedData ? "Yes" : "No",
      sortable: true,
      width:'10%'
    },
    {
      name: "Unsubscribed",
      selector: (row: EmailDetail) =>
        row.isUnsubscribed === null ? "N/A" : row.isUnsubscribed ? "Yes" : "No",
      sortable: true,
      width:'10%'
    },
  ];

  const getSeedListData = (): void => {
    setLoading(true);
    const ClientId = user?.clientId ?? 0;
    getAllSeedListByClientId(ClientId)
      .then((response: ApiResponse) => {
        setLoading(false);
        if (response.status === 200 && response.data.result === 1) {
          const data: any = response.data.data;
          const seedListData: any[] = [];
          if (data && data.length > 0) {
            data.map((item: SeedListPropType) => {
              const formatted = {
                seedListId: item.seedList.id,
                title: item.seedList.title,
                count: item.seedListData.length,
              };
              seedListData.push(formatted);
            });
          }
          setSeedList(seedListData);
         
          if (isEditMode && existingFileData?.originalCampaignData?.seedListId) {
            const selectedIds = String(existingFileData.originalCampaignData.seedListId)
              .split(",")
              .map((id: string) => parseInt(id.trim(), 10));

            const preselected = seedListData.filter((s) =>
              selectedIds.includes(s.seedListId)
            );

            if (preselected.length > 0) {
              setSelectedSeedList(preselected);
            }
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching seed list data:", error);
      })
      .finally(() => setLoading(false));
  };

  const getSuppressionListData = (): void => {
    setLoading(true);
    const ClientId = user?.clientId ?? 0;
    getAllSuppressionListByClientId(ClientId)
      .then((response: SuppressionApiResponse) => {
        if (response.status === 200 && response.data.result === 1) {
          const data: any = response.data.data;
          const suppressionListArr: any[] = [];
          if (data && data.length > 0) {
            data.map((item: SuppressionListPropType) => {
              suppressionListArr.push(item.suppressionList);
            });
          }
          setSuppressionList(suppressionListArr);
          console.log(suppressionListArr);
          console.log(existingFileData?.originalCampaignData?.supressionListId);

          if (isEditMode && existingFileData?.originalCampaignData?.supressionListId) {
            const selectedIds = String(existingFileData.originalCampaignData.supressionListId)
              .split(",")
              .map((id: string) => parseInt(id.trim(), 10));

            const preselected = suppressionListArr.filter((s) =>
              selectedIds.includes(s.suppressionListId)
            );

            if (preselected.length > 0) {
              setSelectedSuppressionList(preselected);
            }
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching suppression list data:", error);
      })
      .finally(() => setLoading(false));
  };

  const mbValue = Math.round(parseInt(MaxRequestBodySizeData) / 1024 / 1024);

  const processAPIResponseData = (responseData: any) : void=> {
    const bulkCampaignSummary = responseData?.bulkCampaignSummary || {};
    
    const emailsUploaded = bulkCampaignSummary.emailsUploadedCount || 0;
    const seedDataCount = bulkCampaignSummary.seedDataCount || 0;
    const emailsSuppressed = bulkCampaignSummary.emailsSuppressed || 0;
    const errors = bulkCampaignSummary.errorsValidationError || 0;
    const complaints = bulkCampaignSummary.ComplaintsCount || 0;
    const totalRecipients =
      (emailsUploaded + seedDataCount) -
      ((bulkCampaignSummary.unsubscribeCount || 0) +
      emailsSuppressed +
      errors);

    if (typeof onTotalRecipientsCalculated === "function") {
      console.log();
      onTotalRecipientsCalculated(totalRecipients,seedDataCount,emailsSuppressed,emailsUploaded);
    }
    
    const summary: SummaryDataType[] = [
      { 
        metric: 'Emails Uploaded', 
        type:'EmailsUploaded',
        count: emailsUploaded, 
        hasInfo: true 
      },
      { 
        metric: 'Emails Suppressed', 
        type:'EmailSupressed',
        count: emailsSuppressed, 
        hasInfo: true 
      },
      { 
        metric: 'Errors', 
        type:'EmailError',
        count: errors, 
        hasInfo: false, 
        isError: true 
      },
      { 
        metric: 'Unsubscribes', 
        type:'EmailUnsubscribed',
        count: bulkCampaignSummary.unsubscribeCount || 0, 
        hasInfo: false 
      },
      { 
        metric: 'Complaints', 
        type:'EmailComplaints',
        count: complaints,
        hasInfo: false 
      },
      { 
        metric: 'Seed List', 
        type:'EmailSeed',
        count: bulkCampaignSummary.seedDataCount || 0, 
        hasInfo: false 
      },
      { 
        metric: 'Total Recipients', 
        type:'EmailTotal',
        count: totalRecipients, 
        hasInfo: false 
      },
    ];

    const domainBreakdown = bulkCampaignSummary.domainBreakdown || [];
    const domains: DomainDataType[] = domainBreakdown.map((item: any) => ({
      domain: item.emailDomain || '',
      percentage: item.percentage || 0,
      count: item.domainCount || 0
    }));

    setSummaryData(summary);
    setDomainData(domains);
    setShowTables(true);
  };

  const triggerUploadApi = async (seed: any[], suppression: any[]): Promise<void> => {
    console.log('Current state values:', {
      bulkCampaignDataIdentifier,
      sourceCSVFileName,
      uploadedCSVFileName,
      seed,
      suppression
    });

    if(!isEditMode){
      if (!bulkCampaignDataIdentifier || !sourceCSVFileName || !uploadedCSVFileName) {
        NotificationManager.error("File is required before uploading.");
        return;
      }
    }

    // Show loader and tables when API call starts
    setIsLoadingTableData(true);
    setShowTables(true);

    const BulkCampaignDataIdentifier = bulkCampaignDataIdentifier;
    try {
      const payload = {
        BulkCampaignDataIdentifier,
        sourceCSVFileName,
        uploadedCSVFileName,
        clientId: user?.clientId ?? 0,
        id: id ?? ''
      };
      console.log("Seed:", seed, typeof seed);
      console.log("Suppression:", suppression, typeof suppression);
      const normalizeValue = (val: unknown): string | null => {
        if (val == null) return null;
        if (typeof val === "object") return null;
        const str = String(val).trim();
        return str && str !== "0" ? str : null;
      };

      const normalizedSeed = normalizeValue(seed);
      const normalizedSuppression = normalizeValue(suppression);

      if (normalizedSeed) {
        //@ts-ignore
        payload.selectedSeedList = normalizedSeed;
      }

      if (normalizedSuppression) {
        //@ts-ignore
        payload.selectedSuppressionList = normalizedSuppression;
      }

      console.log('Payload for upload:', payload);
      const response = await uploadBulkCampaignCsv(payload);

      console.log("Upload Response:", response);
      
      // ✅ Check result first
      if (response.data?.result === 0) {
        NotificationManager.error(response.data?.messages || "Upload failed.");
        setIsLoadingTableData(false);
        return;
      }

      if (response.data?.result === 1) {
        if (!(isEditMode && initialLoadHandledRef.current)) {
          NotificationManager.success("Uploaded successfully.");
        }
        initialLoadHandledRef.current = false;

        if (response.data?.data) {
          processAPIResponseData(response.data.data);
        }
        setIsLoadingTableData(false);
      }
    } catch (error) {
      NotificationManager.error("Error during upload.");
      setIsLoadingTableData(false);
    }
  };

  const handleRemoveFile = (): void => {
    setSelectedFiles([]);
    setBulkCampaignDataIdentifier("");
    setSourceCSVFileName("");
    setUploadedCSVFileName("");
    setShowTables(false);
    setIsLoadingTableData(false);
    setSummaryData([]);
    setDomainData([]);

    setSelectedSeedList(null);
    setSelectedSuppressionList(null);

    if (onSeedListChange) {
      onSeedListChange('');
    }
    if (onSuppressionListChange) {
      onSuppressionListChange('');
    }

    onFileRemoval();
  };

  const handleSeedListChange = (_event: any, newValue: any): void => {
    const selectedValues = newValue || [];
    setSelectedSeedList(selectedValues);

    if (!bulkCampaignDataIdentifier || !sourceCSVFileName || !uploadedCSVFileName) {
      NotificationManager.error("Please upload or select a file before choosing a seed list.");
      return;
    }

    const seedListIds = selectedValues.length > 0
      ? selectedValues.map((s: any) => String(s.seedListId)).join(",")
      : "0";

    const suppressionListIds = (selectedSuppressionList?.length ?? 0) > 0
      ? selectedSuppressionList.map((s: any) => String(s.suppressionListId)).join(",")
      : "0";

    if (lastSeedRef.current !== seedListIds || lastSuppressionRef.current !== suppressionListIds) {
      lastSeedRef.current = seedListIds;
      lastSuppressionRef.current = suppressionListIds;
      void triggerUploadApi(seedListIds, suppressionListIds);
    }

    if (showTables) {
      setSummaryData(prev =>
        prev.map(item =>
          item.metric === "Seed List"
            ? { ...item, count: selectedValues.length }
            : item
        )
      );
    }

    if (onSeedListChange) {
      onSeedListChange(selectedValues.map((s: any) => ({
        id: s.seedListId,
        name: s.title,
      })));
    }
  };

  const handleSuppressionListChange = (_event: any, newValue: any): void => {
    const selectedValues = newValue || [];
    setSelectedSuppressionList(selectedValues);

    if (!bulkCampaignDataIdentifier || !sourceCSVFileName || !uploadedCSVFileName) {
      NotificationManager.error("Please upload or select a file before choosing a suppression list.");
      return;
    }

    const suppressionListIds = selectedValues.length > 0
      ? selectedValues.map((s: any) => String(s.suppressionListId)).join(",")
      : "0";

    const seedListIds = (selectedSeedList?.length ?? 0) > 0
      ? selectedSeedList.map((s: any) => String(s.seedListId)).join(",")
      : "0";

  // ✅ only call API if value changed
    if (lastSuppressionRef.current !== suppressionListIds || lastSeedRef.current !== seedListIds) {
      lastSuppressionRef.current = suppressionListIds;
      lastSeedRef.current = seedListIds;
      void triggerUploadApi(seedListIds, suppressionListIds);
    }

    if (onSuppressionListChange) {
      onSuppressionListChange(selectedValues.map((s: any) => ({
        id: s.suppressionListId,
        name: s.title,
      })));
    }
  };




  const onDrop = useCallback(
    (acceptedFiles: any, rejectedFiles: any) => {
      if (rejectedFiles.length > 0) {
        NotificationManager.error("Please select valid file");
      } else {
        if (MaxRequestBodySizeData !== "") {
          validateFile(acceptedFiles);
        } else {
          NotificationManager.error("Max request body size not available.");
        }
      }
    },
    [MaxRequestBodySizeData]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "text/csv": [".csv"] },
    maxFiles: 1,
  });

 // Update the validateFile function in BulkEmailImportCSV
  const validateFile = (files: File[]): any => {
    const file = files[0];
    if (!file) return;

    if (file.size > parseInt(MaxRequestBodySizeData)) {
      NotificationManager.error(`File size must be less than ${mbValue} MB`);
      return;
    }
    if (file.name.split(".").pop()?.toLowerCase() !== "csv") {
      NotificationManager.error("The file must be in CSV format.");
      return;
    }

    const reader = new FileReader();
    reader.onload = async () => {
      const csv = Papa.parse(reader.result as string, { skipEmptyLines: true });
      if (csv.data.length < 2) {
        NotificationManager.error("The file must contain at least one data record.");
        return;
      }

      const headers = (csv.data[0] as string[]).map((h) =>
        h.toString().replaceAll(' ', "").toLowerCase()
      );
      console.log("CSV Headers:", headers);

  // ✅ Parse required headers safely from API response
      let requiredHeaders: string[] = [];
      try {
        requiredHeaders = JSON.parse(CsvColumnsRequiredData).map((h: string) =>
          h.toString().replaceAll(' ', "").toLowerCase()
        );
      } catch (e) {
        console.error("Failed to parse CsvColumnsRequiredData:", e);
        NotificationManager.error("Invalid required headers format from API.");
        return;
      }
      console.log("Required Headers:", requiredHeaders);

  // ✅ Find missing headers
      const missingHeaders = requiredHeaders.filter(
        (required) => !headers.includes(required)
      );
      if (missingHeaders.length > 0) {
        NotificationManager.error(
          `The uploaded CSV is missing the following required column(s): ${missingHeaders.join(", ")}`
        );
        return;
      }


    // ✅ If validation passes
      setSelectedFiles(files);
      setSelectedSeedList(null);
      setSelectedSuppressionList(null);

      // Show loader when uploading file
      setIsLoadingTableData(true);
      setShowTables(true);

      try {
        const formData = new FormData();
        formData.append("clientId", String(user?.clientId ?? 0));
        formData.append("file", file);
        const response = await uploadBulkCampaignCsv(formData);

        // ✅ Check result first
        if (response.data?.result === 0) {
          NotificationManager.error(response.data?.messages || "File upload failed.");
          // ✅ Clear the selected file
          setSelectedFiles([]);
          setBulkCampaignDataIdentifier("");
          setSourceCSVFileName("");
          setUploadedCSVFileName("");
          setShowTables(false);
          setIsLoadingTableData(false);
          setSummaryData([]);
          setDomainData([]);
          return;
        }

        if (response.data?.result === 1 && response.data?.data) {
          const newBulkCampaignDataIdentifier = response.data.data.bulkCampaignDataIdentifier;
          const newSourceCSVFileName = response.data.data.sourceCSVFileName;
          const newUploadedCSVFileName = response.data.data.uploadedCSVFileName;

          setBulkCampaignDataIdentifier(newBulkCampaignDataIdentifier);
          setSourceCSVFileName(newSourceCSVFileName);
          setUploadedCSVFileName(newUploadedCSVFileName);

          processAPIResponseData(response.data.data);
          setIsLoadingTableData(false);

          onFileUploadSuccess({
            bulkCampaignDataIdentifier: newBulkCampaignDataIdentifier,
            sourceCSVFileName: newSourceCSVFileName,
            uploadedCSVFileName: newUploadedCSVFileName,
            ...response.data.data,
          });

          NotificationManager.success("File has processed successfully.");

          if (selectedSeedList || selectedSuppressionList) {
            setTimeout(() => {
              void triggerUploadApi(selectedSeedList, selectedSuppressionList);
            }, 100);
          }
        }
      } catch (error: any) {
        NotificationManager.error(error?.message || "Error uploading file");
        // ✅ Clear the selected file on error too
        setSelectedFiles([]);
        setBulkCampaignDataIdentifier("");
        setSourceCSVFileName("");
        setUploadedCSVFileName("");
        setShowTables(false);
        setIsLoadingTableData(false);
        setSummaryData([]);
        setDomainData([]);
      }
    };

    reader.readAsText(file);
  };


  const handleCloseEmailDetails = () : void => {
    setShowEmailDetails(false);
    setEmailDetails([]);
  };
  console.log(bulkCampaignDataIdentifier);
  
  return (
    <div style={{ marginTop: "40px" }}>
      <Box sx={{ width: "60%", marginTop: "10px", mx: "auto" }}>
        {selectedFiles.length > 0 ? (
          selectedFiles.map((file) => (
            <div key={file.name} className="dropzone">
              <span className="font-semibold">{file.name}</span>
              <a
                href="javascript:void(0)"
                onClick={handleRemoveFile}
                style={{ color: "red", paddingTop: "10px", marginLeft: "10px" }}
              >
                Remove
              </a>
            </div>
          ))
        ) : isEditMode && sourceCSVFileName ? (
          <div className="dropzone">
            <span className="font-semibold">{sourceCSVFileName}</span>
            <a
              href="javascript:void(0)"
              onClick={handleRemoveFile}
              style={{ color: "red", paddingTop: "10px", marginLeft: "10px" }}
            >
              Remove
            </a>
          </div>

        ) : (
          <div {...getRootProps({ className: "dropzone" })}>
            <input {...getInputProps()} />
            {isDragActive ? (
              <p>Drop the files here ...</p>
            ) : (
              <>
                <p>
                  <strong className="font-semibold">Drag and drop or</strong>
                  <span style={{ color: "#d6242c", cursor: "pointer", fontWeight: "600" }}>
                    {" "}Click here{" "}
                  </span>
                  <strong className="font-semibold">to choose file.</strong>
                </p>
                <span
                  style={{
                    display: "block",
                    marginTop: "20px",
                    fontSize: "14px",
                    color: "#3A3A3A",
                  }}
                >
                  {mbValue && `Max size ${mbValue} MB . `} File format: CSV
                </span>
                <span
                  style={{
                    display: "block",
                    marginTop: "5px",
                    fontSize: "14px",
                    color: "#3A3A3A",
                  }}
                >
                  <a
                    href="/assets/bulkemail-files/Sample.csv"
                    download="sample.csv"
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      color: "#d6242c",
                      textDecoration: "underline",
                      fontWeight: 600,
                    }}
                  >
                    Download
                  </a>{" "}
                  a sample CSV file
                </span>
              </>
            )}
          </div>
        )}

      </Box>

      <div style={{ marginTop: "20px", display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "50px" }}> 
        {/* Seed List */}
        {!showSeedList ? (
          <div className="flex items-center cursor-pointer" style={{ gap: "6px", textDecoration: "underline" }} onClick={() => setShowSeedList(true)}>
            <HugeiconsIcon icon={AddCircleStrokeRounded} size={18} color="#3a3a3a" strokeWidth={0.2} />
            <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              Add seed list
              <CustomTooltip title={CHOOSE_SEEDLIST_MESSAGE} placement="bottom" arrow={false}>
                <span>
                  <HugeiconsIcon icon={HelpCircleIcon} size={18} color="#3a3a3a" strokeWidth={0.2}/>
                </span>
              </CustomTooltip>
            </span>
          </div>
        ) : (
          <div style={{ flex: "0 0 40%" }}>
            <FormControl fullWidth>
              <Controller
                name="seedListIds"
                control={control}
                defaultValue={[]} // store as string[]
                render={({ field }) => {
                  const selected = seedList.filter((s) =>
                    (field.value ?? []).includes(String(s.seedListId))
                  );
                  return (
                    <Autocomplete
                      multiple
                      fullWidth
                      options={seedList}
                      disableCloseOnSelect
                      disableClearable={false}
                      value={selectedSeedList || []}
                      getOptionLabel={(option: any) => option.title}
                      isOptionEqualToValue={(option, value) =>
                        option.seedListId === value?.seedListId
                      }
                      onChange={(_, selectedLists) => {
                        const wasRemoved = (selectedSeedList?.length ?? 0) > selectedLists.length;

                        setSelectedSeedList(selectedLists);
                        field.onChange(selectedLists.map((s) => String(s.seedListId)).join(","));

                        if (wasRemoved) {
                      // ✅ only trigger API on chip removal
                          handleSeedListChange(_, selectedLists);
                        }
                      }}
                      onBlur={(e) => {
                    // ✅ trigger API when focus is lost
                        handleSeedListChange(e, selectedSeedList);
                      }}

                      // ✅ Show only 2 chips, then summarize
                      renderTags={(tagValue, getTagProps) => (
                        <>
                          {tagValue.slice(0, 2).map((option, index) => {
                            const { key, ...tagProps } = getTagProps({ index }); // remove default key
                            return (
                              <Chip
                                key={option.seedListId}
                                label={option.title}
                                {...tagProps}
                                size="small"
                              />
                            );
                          })}
                          {tagValue.length > 2 && (
                            <span style={{ marginLeft: 8, color: "#666" }}>
                              +{tagValue.length - 2}
                            </span>
                          )}
                        </>
                      )}
                      popupIcon={
                        <HugeiconsIcon
                          icon={ArrowDown01Icon}
                          size={18}
                          color="#3A3A3A"
                          strokeWidth={0.5}
                        />
                      }
                      // ✅ Show checkboxes in dropdown
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox style={{ marginRight: 8 }} checked={selected} />
                          {option.title}
                        </li>
                      )}
                      renderInput={(params) => (
                        <>
                          <TextField
                            {...params}
                            fullWidth
                            label="Seed Lists"
                            error={Boolean(errors.seedListIds)}
                          />
                          {errors.seedListIds && (
                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                              <img
                                src="/assets/images/attention.svg"
                                alt="error"
                                width={12}
                                height={12}
                                className="mr-1"
                              />
                              {typeof errors.seedListIds?.message === "string"
                                ? errors.seedListIds.message
                                : ""}
                            </div>
                          )}
                        </>
                      )}
                    />
                  );
                }}
              />
            </FormControl>
          </div>
        )}

        {/* Suppression List */}
        {!showSuppressionList ? (
          <div className="flex items-center cursor-pointer" style={{ gap: "6px", textDecoration: "underline" }} onClick={() => setShowSuppressionList(true)}>
            <HugeiconsIcon icon={AddCircleStrokeRounded} size={18} color="#3a3a3a" strokeWidth={0.2}/>
            <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              Add suppression list
              <CustomTooltip title={CHOOSE_SUPPRESSIONLIST_MESSAGE} placement="bottom" arrow={false}>
                <span>
                  <HugeiconsIcon icon={HelpCircleIcon} size={18} color="#3a3a3a" strokeWidth={0.2}/>
                </span>
              </CustomTooltip>
            </span>
          </div>
        ) : (
          <div style={{ flex: "0 0 40%" }}>
            <FormControl fullWidth>
              <Controller
                name="suppressionListIds"
                control={control}
                defaultValue={[]} // store as string[]
                render={({ field }) => {
                  const selected = suppressionList.filter((s) =>
                    (field.value ?? []).includes(String(s.suppressionListId))
                  );
                  return (
                    <Autocomplete
                      multiple
                      fullWidth
                      options={suppressionList}
                      disableCloseOnSelect
                      disableClearable={false}
                      value={selectedSuppressionList || []}
                      getOptionLabel={(option: any) => option.title}
                      isOptionEqualToValue={(option, value) =>
                        option.suppressionListId === value?.suppressionListId
                      }
                      onChange={(_, selectedLists) => {
                        const wasRemoved = (selectedSuppressionList?.length ?? 0) > selectedLists.length;

                        setSelectedSuppressionList(selectedLists);
                        field.onChange(selectedLists.map((s) => String(s.suppressionListId)).join(","));

                        if (wasRemoved) {
                          handleSuppressionListChange(_, selectedLists);
                        }
                      }}
                      onBlur={(e) => {
                        handleSuppressionListChange(e, selectedSuppressionList);
                      }}

                      // ✅ Show first 2 chips, then summarize count
                      renderTags={(tagValue, getTagProps) => (
                        <>
                          {tagValue.slice(0, 2).map((option, index) => {
                            const { key, ...tagProps } = getTagProps({ index }); // remove default key
                            return (
                              <Chip
                                key={option.suppressionListId} // stable key
                                label={option.title}
                                {...tagProps}
                                size="small"
                              />
                            );
                          })}
                          {tagValue.length > 2 && (
                            <span style={{ marginLeft: 8, color: "#666" }}>
                              +{tagValue.length - 2}
                            </span>
                          )}
                        </>
                      )}
                      popupIcon={
                        <HugeiconsIcon
                          icon={ArrowDown01Icon}
                          size={18}
                          color="#3A3A3A"
                          strokeWidth={0.5}
                        />
                      }
                      // ✅ Add checkboxes
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox style={{ marginRight: 8 }} checked={selected} />
                          {option.title}
                        </li>
                      )}
                      renderInput={(params) => (
                        <>
                          <TextField
                            {...params}
                            fullWidth
                            label="Suppression Lists"
                            error={Boolean(errors.suppressionListIds)}
                          />
                          {errors.suppressionListIds && (
                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                              <img
                                src="/assets/images/attention.svg"
                                alt="error"
                                width={12}
                                height={12}
                                className="mr-1"
                              />
                              {typeof errors.suppressionListIds?.message === "string"
                                ? errors.suppressionListIds.message
                                : ""}
                            </div>
                          )}
                        </>
                      )}
                    />
                  );
                }}
              />
            </FormControl>
          </div>
        )}
      </div>

      {/* Summary and Domain Tables */}
      {showTables && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-10 mx-auto" style={{ maxWidth: "1200px" }}>
          {/* Summary Table - Left Side */}
          <div className= "csv-data mb-4 border rounded-lg bg-white p-2 flex flex-col max-h-[400px]" style={{ borderColor: '#E6ECF2'}}>
            <CustomDataTable
              columns={summaryColumns}
              data={summaryData}
              pagination={false}
              progressPending={isLoadingTableData}
            />
          </div>

          {/* Domain Table - Right Side */}
          <div className="csv-data mb-4 border rounded-lg bg-white flex flex-col max-h-[400px]" style={{ borderColor: '#E6ECF2' }}>
      {/* Table container with horizontal and vertical scroll */}
            <div className="flex-1 overflow-x-auto p-2">
              <CustomDataTable
                columns={domainColumns}
                data={domainData}
                pagination = {domainData.length > 10 ? true : false}
                progressPending={isLoadingTableData}
                fixedHeader
        fixedHeaderScrollHeight="320px"   // controls scroll area height
                customStyles={{
                  headRow: {
                    style: {
                      position: "sticky",
                      backgroundColor: "#fff",
                    },
                  }
                }}
              />
            </div>
          </div>
        </div>
      )}
      
      
      <MUIModal openModal={showEmailDetails} closeModal={handleCloseEmailDetails} title={ selectedMetricName+' Details'} width='50%'>
        <div className="csv-data">
          <CustomDataTable
            columns={emailDetailsColumns}
            data={emailDetails}
            pagination
            progressPending={emailDetailsLoading}
          />
        </div>
      </MUIModal>
    </div>
  );
}